export const alwaysNew = <C, N>(_: C, newVal: N) => newVal;
